(() => {
  if (customElements.get('tdc-card-swatches')) return;
  class TdcCardSwatches extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.card = this.closest('product-item');
      this.options = Array.from(this.querySelectorAll('[data-tdc-swatch]'));
      this.more = this.querySelector('[data-tdc-more]');
      this.list = this.querySelector('.tdc-card-swatches__list');
      if (!this.card || !this.options.length || !this.more) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-tdc-swatch]');
        if (!option || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.select(option);
      }, { signal });
      this.addEventListener('keydown', event => {
        const option = event.target.closest('[data-tdc-swatch]');
        if (option && event.key === ' ') {
          event.preventDefault();
          this.select(option);
        }
      }, { signal });
      this.more.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.layout();
      }, { signal });
      if (this.options.every(option => option.getAttribute('role') === 'button')) {
        this.addEventListener('pointerover', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
          const option = event.target.closest('[data-tdc-swatch]');
          if (option && !option.contains(event.relatedTarget)) this.select(option);
        }, { signal });
      }
      this.resize = new ResizeObserver(() => this.layout());
      this.resize.observe(this);
      this.layout();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = null;
    }
    layout() {
      const styles = getComputedStyle(this);
      const size = parseFloat(styles.getPropertyValue('--tdc-swatch-size')) || 36;
      const gap = parseFloat(styles.getPropertyValue('--tdc-swatch-gap')) || 6;
      const width = this.list.getBoundingClientRect().width;
      if (!width) return;
      const capacity = Math.max(1, Math.floor((width + gap - 0.5) / (size + gap)));
      const limit = Math.max(1, Number(this.dataset.limit) || 5);
      const count = this.options.length;
      const visible = count <= capacity && count <= limit ? count : Math.max(1, Math.min(limit, capacity - 1));
      this.options.forEach((option, index) => { option.hidden = !this.expanded && index >= visible; });
      const remaining = count - visible;
      this.more.hidden = remaining === 0;
      this.more.textContent = this.expanded ? '−' : `+${remaining}`;
      this.more.setAttribute('aria-expanded', String(Boolean(this.expanded)));
      this.more.setAttribute('aria-label', this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel.replace('[count]', remaining));
    }
    select(option) {
      if (this.selected === option) return;
      this.selected = option;
      this.options.forEach(item => item.setAttribute('aria-pressed', String(item === option)));
      const primary = this.card.querySelector('.product-item__primary-image');
      if (primary && option.dataset.imageSrc) {
        primary.srcset = option.dataset.imageSrcset;
        primary.src = option.dataset.imageSrc;
        primary.alt = option.dataset.imageAlt;
        primary.dataset.mediaId = option.dataset.mediaId;
        primary.hidden = false;
        this.card.classList.add('tdc-variant-preview');
      }
      this.card.querySelectorAll('.product-item__aspect-ratio, .product-item-meta__title, .product-item-meta__reviews-badge, quick-buy-popover[href], quick-buy-drawer[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('variant', option.dataset.variantId);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
      const price = this.card.querySelector('.product-item-meta__price-list-container .price-list');
      const template = option.querySelector('[data-tdc-price]');
      if (price && template) price.replaceChildren(template.content.cloneNode(true));
      const discountTemplate = option.querySelector('[data-tdc-discount]');
      if (discountTemplate) {
        const discountLabel = discountTemplate.content.querySelector('.label--highlight');
        let labels = this.card.querySelector('.product-item__label-list');
        if (discountLabel && !labels) {
          labels = document.createElement('div');
          labels.className = 'product-item__label-list label-list';
          this.card.querySelector('.product-item__image-wrapper')?.prepend(labels);
        }
        if (labels) {
          labels.querySelector('.label--highlight')?.remove();
          if (discountLabel) labels.append(discountTemplate.content.cloneNode(true));
          if (!labels.children.length) labels.remove();
        }
      }
      const installment = this.card.querySelector('[data-tdc-installment-value]');
      const installmentTemplate = option.querySelector('[data-tdc-installment]');
      if (installment && installmentTemplate) installment.textContent = installmentTemplate.content.textContent.trim();
    }
  }
  customElements.define('tdc-card-swatches', TdcCardSwatches);
})();
